
import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Special handling for URL inputs to be more forgiving
    const handleUrlInput = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (type === 'url' && props.onChange) {
        // Remove validation errors by converting type to text for onChange
        const textEvent = {
          ...e,
          target: {
            ...e.target,
            type: 'text'
          }
        } as React.ChangeEvent<HTMLInputElement>;
        
        props.onChange(textEvent);
      } else if (props.onChange) {
        props.onChange(e);
      }
    };
    
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        onChange={handleUrlInput}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
